import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

import { NotFoundView } from '../../../NotFoundView';

export const SierraErrorMessage = () => {
  return (
    <View style={styles.errorContainer}>
      <NotFoundView.Title sizeMatch={['32']} />
      <NotFoundView.Image />
      <NotFoundView.Description />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  errorContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing['4'],
    paddingHorizontal: theme.spacing['8'],
    backgroundColor: theme.colors.WHITE,
  },
});
